export enum MyInvestmentFilter {
  MOST_PROFIT = 'Most Profit',
  LEAST_PROFIT = 'Least Profit',
  OLDEST = 'Oldest',
  NEWEST = 'Newest',
}
